<template>
  <div>
    <v-card flat>
      <v-card-title class="body-2 v-card__subtitle">
        <v-icon left small class="mr-2">mdi-tag</v-icon>
        Besetzbare Funktionen
      </v-card-title>
      <v-card-text>
        <div v-if="!fillablePositions.length">Keine Funktionen besetzbar</div>
        <v-chip
          v-else
          v-for="(position, index) in fillablePositions"
          :key="index"
          label
          :small="smallChips"
          class="font-weight-medium text--darken-4 mr-2 mb-2"
          v-bind:style="createBorderColorStyle(position.color)"
        >
          {{ position.title }}
        </v-chip>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "personnel-record-detail-card-content-fillable-positions",
  props: {
    member: {
      type: Object,
      required: true,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    smallChips: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fillablePositions() {
      if (!this.member?.fillablePositions?.data) {
        return [];
      }
      // Sort by priority (lower number = higher priority)
      return [...this.member.fillablePositions.data].sort(
        (a, b) => (a.priority || 0) - (b.priority || 0)
      );
    },
  },
  methods: {
    createBorderColorStyle(color) {
      const style = "border-left: 12px solid " + color;
      return style;
    },
  },
};
</script>
